export default "__VITE_ASSET__CcaBIDx6__"